import { DropdownChangeEvent } from "primereact/dropdown";
import { mapCategories } from "../../config/CategoryMapping";
import { useCallback, useEffect, useState } from "react";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectDefectCodeCategories } from "../../store/selectors/defectSelectors";
import { Category } from "../../config/CategoryMapping";

type Props = {
    options: ColumnFilterElementTemplateOptions;
    onFilterChange: (value: string | null) => void;
};

export const DefectCodeFilter = ({ options, onFilterChange }: Props) => {
    const categories = useAppSelector(selectDefectCodeCategories);
    const [codeOptions, setCodeOptions] = useState<Category[]>([]);

    useEffect(() => {
        setCodeOptions(mapCategories(categories));
    }, [categories]);

    const onChange = useCallback((event: DropdownChangeEvent) => {
        onFilterChange(event.value || null);
    }, [onFilterChange]);

    return (
        <Dropdown
            value={options.value}
            options={codeOptions}
            onChange={onChange}
            filter
            showClear
            placeholder="Search by Category"
            scrollHeight="400px"
            optionLabel="label"
            optionValue="value"
        />
    );
};

